module.exports = __webpack_public_path__ + "media/images/flags/4x3/dom-112f9da25cf6a972d21707cbf0c804ec.svg";